import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const PhotoPassIcon = ({ color = '#0d84fe', size = '27', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 27 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5 18.857v.786c0 1.302-1.007 2.357-2.25 2.357h-18C1.007 22 0 20.945 0 19.643V7.07C0 5.77 1.007 4.714 2.25 4.714H3V14.93c0 2.166 1.682 3.928 3.75 3.928H22.5zM27 14.93V2.357C27 1.055 25.993 0 24.75 0h-18C5.507 0 4.5 1.055 4.5 2.357V14.93c0 1.301 1.007 2.357 2.25 2.357h18c1.243 0 2.25-1.056 2.25-2.357zM12 4.714c0 1.302-1.007 2.357-2.25 2.357S7.5 6.016 7.5 4.714c0-1.302 1.007-2.357 2.25-2.357S12 3.412 12 4.714zm-4.5 7.072l2.602-2.726c.22-.23.576-.23.796 0L12.75 11l6.352-6.655c.22-.23.576-.23.796 0L24 8.643v5.5H7.5v-2.357z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

PhotoPassIcon.propTypes = propTypes;

export default PhotoPassIcon;
